import Icon from '../../components/Icon.vue';
Icon.register({
  'brands/opera': {
    width: 496,
    height: 512,
    paths: [{
      d: 'M313.9 32.7c-170.2 0-252.6 223.8-147.5 355.1 36.5 45.4 88.6 75.6 147.5 75.6 36.3 0 70.3-11.1 99.4-30.4-43.8 39.2-101.9 63-165.3 63-3.9 0-8 0-11.9-0.3-131.5-6.1-236.1-114.6-236.1-247.7 0-137 111-248 248-248h0.8c63.1 0.3 120.7 24.1 164.4 63.1-29-19.4-63.1-30.4-99.3-30.4zM415.7 430.4c-40.9 24.7-90.7 23.6-132-5.8 56.2-20.5 97.7-91.6 97.7-176.6 0-84.7-41.2-155.8-97.4-176.6 41.8-29.2 91.2-30.3 132.9-5 105.9 98.7 105.5 265.7-1.2 364z'
    }]
  }
});